import accountReducer from "./accountReducer";

export const accountReducers = {
  account: accountReducer,
};
